export default "__VITE_ASSET__C1bN3IF8__"